import { COUNTRY_CODE } from 'modules/country/constants/code'
import { COUNTRY_NAME } from 'modules/country/constants/name'
import { getCountryFromCodeCountryUtil } from 'modules/country/utils/get-country-from-code'
import { splitAndTrimAll } from 'utils/string'

/**
 * Returns the country code of the current user.
 * e.g.  'San Antonio, TX, US' => 'US'
 * Default to CA_
 *
 * @param  {User} user
 * @returns {string}
 */
function getCountryCodeUserUtil (user) {
  const { location } = user.data
  if (!location) {
    return COUNTRY_CODE[COUNTRY_NAME.UNITED_STATES]
  }
  return splitAndTrimAll(location, ',')[2]
}

/**
 * Returns the country name where the user is probably in.
 * e.g. 'San Antonio, TX, US' => 'United States'
 *
 * @param  {User} user
 * @returns {string}
 */
function getCountryUserUtil (user) {
  const countryCode = getCountryCodeUserUtil(user)
  return getCountryFromCodeCountryUtil(countryCode)
}

export {
  getCountryUserUtil,
  getCountryCodeUserUtil
}
